import React from "react";
import { useTranslation } from "react-i18next";
import {   useParams } from "react-router-dom";
import TableLabels from "./TableLabels"; 
import { QRCode } from "antd"; 

const VariantsTableRow = ({ payments_list, alt_name, handleLoader }) => {
 

  const {  lang } = useParams();
  const [_] = useTranslation("global");
  
  return (
    <div
      className={`table-responsive wow my-3 d-flex ${
        lang === "en" ? "flex-row" : "flex-row-reversed"
      } align-items-center`}
    >
      <table
        className="table table-borderless text-nowrap"
        htmlFor="flexCheckDefault"
      >
        <thead>
          <TableLabels />
        </thead>
        <tbody>
          {payments_list.map((order) => {
            const dateSegments = order["created_at_formatted"].split(" ");

            return (
              <tr className="">
                <td className="align-middle">
                  <div
                    className="form-check mt-3 d-flex justify-content-center align-items-center"
                    style={{ paddingLeft: "2.24rem", paddingRight: "7px" }}
                  >
                    <input
                      className="form-check-input"
                      style={{
                        border: "1px solid rgba(243, 168, 55, 1)",
                        transform: "translate(-0%, -50%)",
                      }}
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                  </div>
                </td>
                <td scope="row" className="align-middle">
                  {dateSegments[0]} <br /> {dateSegments[1]} {dateSegments[2]}
                </td>
                <td className="align-middle">
                  <img
                    src={order["thumbnail"]}
                    width={"69px"}
                    className="rounded"
                  />
                </td>
                <td className="align-middle">
                  {order["product_title"].substring(0, 13) + "..."} <br />#
                  {order["product_id"]}
                </td>
                <td className="align-middle">
              
                {order["color"] || "__"}                </td>
                <td className="align-middle">{order["size"] || "__"}</td>
                <td className="align-middle">{order["sku"]}</td>
                <td className="align-middle
                ">
                  <QRCode
                    value={order["sku"]}
                    icon={
                      " data:image/png;base64,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"
                    }
                    // iconSize={'50px'}
                    // size={'100px'}
                    size={120}
                  />
                </td>
                <td className="align-middle">{order["total"]}</td>
                <td className="align-middle">{order["left"]}</td>
                <td className="align-middle">{order["title"]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default VariantsTableRow;
